import { Component } from '@angular/core';
import { ShimmerLoadingComponent } from '../shimmer-loading/shimmer-loading.component';
import { ConfigService } from '../core';
import { map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { whiteLabelNames } from 'src/app/appsettings';
import { combineLatest } from 'rxjs';

@Component({
	selector: "app-shimmer-loading-patientweb",
	standalone: true,
	imports: [ShimmerLoadingComponent, CommonModule],
	templateUrl: "./shimmer-loading-patientweb.component.html",
	styleUrl: "./shimmer-loading-patientweb.component.scss",
})
export class ShimmerLoadingPatientwebComponent {
	isUkDfp$ = this.config.config$.pipe(
		map((config) => config.WhiteLabelName === whiteLabelNames.UK_DFP)
	);
	isGlobal$ = this.config.config$.pipe(
		map((config) => config.WhiteLabelName === whiteLabelNames.GLOBAL)
	);

	logo$ = combineLatest([this.isUkDfp$, this.isGlobal$]).pipe(
    map(([isUkDfp, isGlobal]) => {
      if (isGlobal) {
        return '/assets/img/global-synlab-logo.png';
      } else if (isUkDfp) {
        return '/assets/img/ukdfplogo.png';
      } else {
        return '/assets/img/synlab-logo.svg';
      }
    })
	);

	constructor(private config: ConfigService) {}
}
